import React, { startTransition } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import documentTextIcon from '../../DocumentCollection/Assets/document-text.svg';
import documentCollectedIcon from '../../DocumentCollection/Assets/tick-icon.svg';
import { documentCollectionPathFromLink } from '../helpers/buildDocumentCollectionLink';

export const CollectionPrereqsStyles = {
  Container: {
    marginTop: '24px',
    padding: '16px',
    backgroundColor: '#2F6358',
  },
  Heading: {
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
  },
  Cards: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  Card: {
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  Icon: {
    height: 32,
    width: 32,
    marginRight: '8px',
  },
  CardTitle: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 600,
    color: '#3c3c3c',
    flexShrink: 1,
  },
  FillButton: {
    marginLeft: 'auto',
    minWidth: 72,
    height: 32,
    textTransform: 'none',
    borderRadius: '8px',
    border: '1px solid #ff970a',
    color: '#ff970a',
    ':hover': {
      border: '1px solid #ff970a',
      backgroundColor: 'rgba(255, 151, 10, 0.08)',
    },
  },
  Checked: {
    marginLeft: 'auto',
    height: 20,
    width: 20,
  },
};

const CollectionPrereqs = ({ documentData, onOpenDocuments }) => {
  const navigate = useNavigate();
  const showDocs = documentData?.document_collection_status === 'PENDING';

  // if (!showDocs) {
  //   return null;
  // }

  const openDocuments = () => {
    const path = documentCollectionPathFromLink(documentData?.document_collection_link);
    if (!path) {
      return;
    }
    if (onOpenDocuments) {
      onOpenDocuments(documentData);
    }
    startTransition(() => {
      sessionStorage.setItem('navigate-from', window.location.href);
      navigate(path);
    });
  };

  return (
    <Box sx={CollectionPrereqsStyles.Container}>
      <Typography sx={CollectionPrereqsStyles.Heading}>
        Pre-requisites
      </Typography>
      <Box sx={CollectionPrereqsStyles.Cards}>
        <Box sx={CollectionPrereqsStyles.Card}>
          <img
            src={documentTextIcon}
            alt=""
            style={CollectionPrereqsStyles.Icon}
          />
          <Typography sx={CollectionPrereqsStyles.CardTitle}>
            Documents
          </Typography>
          {showDocs ? (
            <Button
              sx={CollectionPrereqsStyles.FillButton}
              onClick={openDocuments}
            >
              Fill
            </Button>
          ) : (
            <img
              src={documentCollectedIcon}
              alt=""
              style={CollectionPrereqsStyles.Checked}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

CollectionPrereqs.propTypes = {
  documentData: PropTypes.shape({
    document_collection_status: PropTypes.string,
    document_collection_link: PropTypes.string,
  }),
  onOpenDocuments: PropTypes.func,
};

export default CollectionPrereqs;

export function documentsCollectionPending(documentData) {
  return documentData?.document_collection_status === 'PENDING';
}
